import { authFire, dbFirestore } from '../appFirebase';
import { addDocToCollection } from './dbUtils';


export const addUserAssessment = async newUserAssessment => {
	const userId = authFire.currentUser.uid;
	const userAssessment = await addDocToCollection(`users/${userId}/assessments`, newUserAssessment );
	return { id: userAssessment.id, ...newUserAssessment };
};
